enum ComplaintType {
  IncorrectFinalState = "chybnyStavMeridla",
  Other = "jineDuvody",
  IncorrectBilling = "vyuctovaniZalohy",
}

export default ComplaintType;
